module.exports = __webpack_public_path__ + "94f26fbb227d0277e1d49f3469a057c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/news/img1_2.jpg
// module id = 280
// module chunks = 0